import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { parentPath } from './parentPath.js';
import './BackButton.css';

// BackButton steps back one level on every page except home. Mobile only
// (rendered in Dashboard.js's mobile top bar): desktop has the browser's Back
// button and an always-visible sidebar. After in-app navigation it returns to
// the previous page, so a lot's "Animals" row (which opens the top-level
// Animals tab) comes back to the lot. React Router keeps its own history index
// in history.state.idx; 0 means this is the first page in the tab, so there's
// nothing in-app to go back to.
const BackButton = ({ className = '' }) => {
  const navigate     = useNavigate();
  const { pathname } = useLocation();
  const { t }        = useTranslation();

  if (pathname === '/') return null;

  const goBack = () => {
    if ((window.history.state?.idx ?? 0) > 0) navigate(-1);
    else navigate(parentPath(pathname));
  };

  return (
    <button className={`back-button ${className}`} onClick={goBack} data-testid="back-button">
      ← {t('back')}
    </button>
  );
};

export default BackButton;
